/* This is a way to access environment variables in a React app. */
/* Importing constants from Encounter.ValueSets.js file. */
import { V3_ACT_ENCOUNTER_CODE } from './Encounter.utils.ValueSets';

// const { REACT_APP_DOMAIN } = process.env;

/**
 * * It takes a set of values and returns a Encounter resource in FHIR format
 * @param values - The values from the form
 * @returns A encounterData object.
 */
export function mEncounter(values) {
  const encounterData = {
    resourceType: 'Encounter',
  };

  if (values.id !== '') {
    encounterData.id = values.id;
  }

  if (values.status !== '') {
    encounterData.status = values.status;
  }

  if (values.class !== '') {
    encounterData.class = V3_ACT_ENCOUNTER_CODE.values
      .filter((obj) => obj.code === values.class)
      .map((p) => ({
        system: p.system,
        code: p.code,
        display: p.display,
      }))[0];
  }

  if (values.period_start !== '' || values.period_end !== '') {
    encounterData.period = {};
    if (values.period_start !== '') {
      encounterData.period.start = values.period_start;
    }
    if (values.period_end !== '') {
      encounterData.period.end = values.period_end;
    }
  }

  if (values.subject !== '') {
    encounterData.subject = {
      reference: `Patient/${values.subject}`,
      type: 'Patient',
    };
  }

  if (values.location !== '') {
    encounterData.location = [
      {
        location: {
          reference: `Location/${values.location}`,
          type: 'Location',
        },
      },
    ];
  }

  if (values.diagnosis_condition !== '') {
    encounterData.diagnosis = [
      {
        condition: {
          reference: `Condition/${values.diagnosis_condition}`,
          type: 'Condition',
        },
      },
    ];
  }

  return encounterData;
}
